<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Wowza License</span>
          <span v-else>Create a New Wowza License</span>
        </h1>
        <span>
          <router-link :to="{ name: 'wowza-licenses' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row', { has_error: errorFor('host_name') }]">
                <label class="required">Host name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="wowzaLicense.host_name"
                  />
                  <v-errors :errors="errorFor('host_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('ip') }]">
                <label class="required">IP</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="wowzaLicense.ip"
                  />
                  <v-errors :errors="errorFor('ip')"></v-errors>
                </div>
              </div>

              <div
                :class="['form_row', { has_error: errorFor('customer_name') }]"
              >
                <label class="required">Customer name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="wowzaLicense.customer_name"
                  />
                  <v-errors :errors="errorFor('customer_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('license') }]">
                <label class="required">License</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="wowzaLicense.license"
                  />
                  <v-errors :errors="errorFor('license')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('memo') }]">
                <label>Memo</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="wowzaLicense['memo']"
                    :id="'memo'"
                  ></text-editor>
                  <v-errors :errors="errorFor('memo')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusActive"
                    v-model="wowzaLicense.status"
                    value="1"
                  />
                  <label for="statusActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusInactive"
                    v-model="wowzaLicense.status"
                    value="0"
                  />
                  <label for="statusInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('status')"></v-errors>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('certification') }]"
              >
                <label class="required">Certification</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="wowzaLicense.certification"
                  />
                  <v-errors :errors="errorFor('certification')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('register_date') }]"
              >
                <label class="required">Register date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="wowzaLicense.register_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('register_date')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('expire_date') }]"
              >
                <label class="required">Expire date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="wowzaLicense.expire_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('expire_date')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'wowza-licenses' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'wowza-license-form',
  components: { LoaderMaskComponent, TextEditor, DatePicker },
  data() {
    return {
      lyLoading: false,
      wowzaLicense: {
        host_name: '',
        ip: '',
        customer_name: '',
        license: '',
        certification: '',
        register_date: '',
        expire_date: '',
        status: 1,
        memo: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(wowzaLicenseId) {
      this.lyLoading = true;
      this.axios
        .get('/wowza-licenses/' + wowzaLicenseId)
        .then((response) => {
          this.wowzaLicense = response.data.data;
          this.wowzaLicense.status = response.data.data.status ? 1 : '0';
        })
        .catch(() => {
          this.showFailMsg('No wowza license exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.wowzaLicense).forEach((key) => {
        formData.append(
          key,
          this.wowzaLicense[key] ? this.wowzaLicense[key] : ''
        );
      });

      this.axios
        .post('/wowza-licenses', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Wowza License Created Successfully!');
          this.$router.push({ name: 'wowza-licenses' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.wowzaLicense).forEach((key) => {
        formData.append(
          key,
          this.wowzaLicense[key] ? this.wowzaLicense[key] : ''
        );
      });

      this.axios
        .post('/wowza-licenses/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Wowza License Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.wowzaLicense = {
        host_name: '',
        ip: '',
        customer_name: '',
        license: '',
        certification: '',
        register_date: '',
        expire_date: '',
        status: 1,
        memo: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
